const ChairishContext = window.chairisher.context;

export function isDesktopUserAgent() {
    return ChairishContext.IS_DESKTOP_USER_AGENT;
}

export function isMaxMediumDesktop() {
    return window.matchMedia('(max-width: 991px)').matches;
}

export function isMaxPhone() {
    return window.matchMedia('(max-width: 480px)').matches;
}

export function isMaxTablet() {
    return window.matchMedia('(max-width: 767px)').matches;
}

export function isMinMediumDesktop() {
    return window.matchMedia('(min-width: 768px)').matches;
}

export function isMinLargeDesktop() {
    return window.matchMedia('(min-width: 992px)').matches;
}

export function isTouchDevice() {
    return 'ontouchstart' in window;
}

export function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
